/* ============================================================
   Bellvari — Crazy Horse Gift Set (2026-05)
   Project-layer JS. Extends bellvari.js (which must load first).
   Handles:
     - Top-banner dismiss (sessionStorage)
     - Occasions seasonal chip (toggle state on section setting)
     - What's in the box: no JS needed (CSS hover + bv-reveal handles it)
   ============================================================ */

(function () {
  'use strict';

  /* ============================================================
     TOP BANNER — dismiss and persist via sessionStorage
     ============================================================ */

  function initBanner() {
    var banner = document.querySelector('[data-bv-gs-banner]');
    if (!banner) return;

    var KEY = 'bv-gs-banner-dismissed';

    // Already dismissed this session — hide immediately, no flash
    if (sessionStorage.getItem(KEY)) {
      banner.setAttribute('data-dismissed', '');
      return;
    }

    var dismissBtn = banner.querySelector('[data-bv-gs-banner-dismiss]');
    if (!dismissBtn) return;

    dismissBtn.addEventListener('click', function () {
      sessionStorage.setItem(KEY, '1');
      // Animate out gracefully before removing from layout
      banner.style.transition = 'opacity 0.25s ease, max-height 0.35s ease';
      banner.style.overflow = 'hidden';
      banner.style.opacity = '0';
      banner.style.maxHeight = banner.offsetHeight + 'px';
      requestAnimationFrame(function () {
        banner.style.maxHeight = '0';
      });
      setTimeout(function () {
        banner.setAttribute('data-dismissed', '');
        banner.style.cssText = ''; // clean up inline styles
      }, 380);
    });
  }

  /* ============================================================
     SEASONAL CHIP — state is controlled by Liquid (show_seasonal_chip)
     No JS toggling needed at runtime. This watcher only exists so a
     future operator can toggle chips dynamically without a theme deploy.
     Currently a no-op unless [data-bv-chip-toggle] exists in the DOM.
     ============================================================ */

  function initSeasonalChip() {
    var toggle = document.querySelector('[data-bv-chip-toggle]');
    if (!toggle) return; // no dynamic toggle in page — Liquid handles it

    var chips = document.querySelectorAll('.bv-occasion-chip');
    if (chips.length === 0) return;

    toggle.addEventListener('change', function () {
      var show = toggle.checked;
      chips.forEach(function (chip) {
        chip.style.display = show ? '' : 'none';
      });
    });
  }

  /* ============================================================
     MOBILE CAROUSEL ARROWS — colorways + what's-in-the-box
     bv-colorways is SHARED across PDPs, so we don't fork it; this page-scoped
     script wraps the existing grid and injects prev/next arrows styled to match
     the anatomy carousel. CSS hides the arrows above 640px, where both grids
     are static multi-column layouts with nothing to scroll.
     ============================================================ */

  function initCarouselArrows(gridSelector, cardSelector, noun) {
    var grid = document.querySelector(gridSelector);
    if (!grid) return;
    if (grid.parentElement && grid.parentElement.classList.contains('bv-cw-carousel')) return;

    var wrap = document.createElement('div');
    wrap.className = 'bv-cw-carousel';
    grid.parentNode.insertBefore(wrap, grid);
    wrap.appendChild(grid);

    function makeArrow(dir, label, glyph) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bv-cw-arrow ' + dir;
      b.setAttribute('aria-label', label);
      b.textContent = glyph;
      wrap.appendChild(b);
      return b;
    }
    var prev = makeArrow('prev', 'Previous ' + noun, '←');
    var next = makeArrow('next', 'Next ' + noun, '→');

    function step() {
      var card = grid.querySelector(cardSelector);
      if (!card) return Math.round(grid.clientWidth * 0.8);
      var cs = getComputedStyle(grid);
      var gap = parseFloat(cs.columnGap || cs.gap) || 14;
      return card.getBoundingClientRect().width + gap;
    }

    prev.addEventListener('click', function () { grid.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { grid.scrollBy({ left: step(), behavior: 'smooth' }); });

    function sync() {
      var max = grid.scrollWidth - grid.clientWidth - 2;
      prev.disabled = grid.scrollLeft <= 2;
      next.disabled = grid.scrollLeft >= max;
    }
    grid.addEventListener('scroll', function () { window.requestAnimationFrame(sync); });
    window.addEventListener('resize', sync);
    sync();
  }

  /* ============================================================
     BOOT
     ============================================================ */

  function boot() {
    initBanner();
    initSeasonalChip();
    initCarouselArrows('.bv-colorways-grid', '.bv-colorway', 'colorway');
    initCarouselArrows('.bv-witb-grid', '.bv-witb-panel', 'item');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
